import React from 'react';
import { observer } from 'mobx-react';
import { LocalizationFlags, SportSliderDict } from '@draftkings/sportsbook-common-contracts';
import { Slider } from '../Slider';
import { AppContextProvider } from '../../contexts';
import { IState } from '../../contracts';

import '../../index.css';

type AppProps = {
    dataProvider: IState;
    dictionary: SportSliderDict;
    locale?: string;
    localizationFlags?: LocalizationFlags;
    renderLoader: () => JSX.Element;
};

class AppComponent extends React.Component<AppProps, IState> {
    constructor(props: AppProps) {
        super(props);
    }

    render() {
        const hasNoAvailableCards = this.props.dataProvider.cards.length === 0 && this.props.dataProvider.isLoaded;

        if (hasNoAvailableCards || this.props.dataProvider.isError) {
            return null;
        }

        if (this.props.dataProvider.isLoading) {
            return this.props.renderLoader();
        }

        return (
            <AppContextProvider
                value={{
                    dictionary: this.props.dictionary,
                    locale: this.props.locale,
                    localizationFlags: this.props.localizationFlags
                }}
            >
                {this.props.dataProvider.isLoaded && this.props.dataProvider.cards.length >= 0 && (
                    <Slider
                        cards={this.props.dataProvider.cards}
                        isEventSliderRedesign={this.props.dataProvider.isEventSliderRedesign}
                        onClick={this.props.dataProvider.onCardClick}
                    />
                )}
            </AppContextProvider>
        );
    }
}

export const App = observer(AppComponent);
